module.exports = __webpack_public_path__ + "img/sliders.6b1c7327.svg";